export interface IDistributionCountry {
  countryCode: string;
  currency: string;
  id: string;
  price: number;
}
